import { Icon } from "@chakra-ui/react";
import React from "react";

/**
 * Renders the hazard lights icon
 * 
 * @param {Object} props - The props of the component
 * @returns The hazard lights icon
 */
const HazardLightsIcon = (props) => (
  <Icon viewBox="0 0 40 35" fill="none" {...props}>
    <path d="M0 34.7728L20 0.227295L40 34.7728H0ZM6.27273 31.1364H33.7273L20 7.50002L6.27273 31.1364ZM20 29.3182C20.5152 29.3182 20.947 29.144 21.2955 28.7955C21.6439 28.447 21.8182 28.0152 21.8182 27.5C21.8182 26.9849 21.6439 26.5531 21.2955 26.2046C20.947 25.8561 20.5152 25.6818 20 25.6818C19.4848 25.6818 19.053 25.8561 18.7045 26.2046C18.3561 26.5531 18.1818 26.9849 18.1818 27.5C18.1818 28.0152 18.3561 28.447 18.7045 28.7955C19.053 29.144 19.4848 29.3182 20 29.3182ZM18.1818 23.8637H21.8182V14.7727H18.1818V23.8637Z" fill="currentColor" />
  </Icon>
);

export default React.memo(HazardLightsIcon);
